<ng-container *ngIf="(!pinnedRow && moreThanOneInList) || params.tableOptional">
  <button
    mat-icon-button
    #buttonTrigger="matMenuTrigger"
    [matMenuTriggerFor]="rowOptionsMenu"
    [matMenuTriggerData]="{}"
    aria-label="Row Options"
    class="semantic-button"
    style="margin: auto; padding: auto"
  >
    <span class="screenreader">Row Options</span>
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #rowOptionsMenu>
    <ng-template matMenuContent let-id="id">
      <button mat-menu-item (click)="editRow(rowNode)" *ngIf="params.showEdit">
        <mat-icon>edit</mat-icon>
        Edit
      </button>
      <button
        mat-menu-item
        (click)="checkpointOnRow(rowNode)"
        class="checkpoint-btn"
        *ngIf="canSubmitCheckpoints && params.showCheckpoint && noOkay"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.25 7H0.750001C0.335781 7 0 7.33578 0 7.75V15.25C0 15.6642 0.335781 16 0.750001 16H3.25C3.66422 16 4 15.6642 4 15.25V7.75C4 7.33578 3.66422 7 3.25 7ZM2 14.75C1.58578 14.75 1.25 14.4142 1.25 14C1.25 13.5858 1.58578 13.25 2 13.25C2.41422 13.25 2.75 13.5858 2.75 14C2.75 14.4142 2.41422 14.75 2 14.75ZM12 2.54538C12 3.87088 11.1884 4.61438 10.9601 5.5H14.1389C15.1826 5.5 15.9951 6.36706 16 7.31556C16.0026 7.87613 15.7642 8.47959 15.3925 8.85297L15.3891 8.85641C15.6964 9.58569 15.6465 10.6076 15.0982 11.3398C15.3695 12.149 15.096 13.1431 14.5863 13.676C14.7206 14.2259 14.6564 14.6939 14.3941 15.0707C13.7563 15.9871 12.1755 16 10.8387 16L10.7498 16C9.24085 15.9994 8.00588 15.45 7.01357 15.0086C6.51491 14.7867 5.86291 14.5121 5.36822 14.503C5.16385 14.4993 5 14.3325 5 14.1281V7.44775C5 7.34775 5.04007 7.25178 5.11119 7.18147C6.34913 5.95822 6.88144 4.66313 7.8961 3.64675C8.35872 3.18325 8.52697 2.48312 8.68963 1.80606C8.8286 1.22791 9.11929 0 9.75001 0C10.5 0 12 0.25 12 2.54538Z"
            fill="currentcolor"
          />
        </svg>

        Submit
      </button>
      <button
        mat-menu-item
        (click)="duplicateRow(rowNode)"
        class="duplicate-btn"
        *ngIf="params.showDuplicate"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5607 2.06066L11.9393 0.439344C11.658 0.158039 11.2765 2.08024e-06 10.8787 0L5.5 0C4.67156 0 4 0.671562 4 1.5V3H1.5C0.671563 3 0 3.67156 0 4.5V14.5C0 15.3284 0.671563 16 1.5 16H8.5C9.32844 16 10 15.3284 10 14.5V13H12.5C13.3284 13 14 12.3284 14 11.5V3.12131C14 2.72349 13.842 2.34196 13.5607 2.06066ZM8.3125 14.5H1.6875C1.63777 14.5 1.59008 14.4802 1.55492 14.4451C1.51975 14.4099 1.5 14.3622 1.5 14.3125V4.6875C1.5 4.63777 1.51975 4.59008 1.55492 4.55492C1.59008 4.51975 1.63777 4.5 1.6875 4.5H4V11.5C4 12.3284 4.67156 13 5.5 13H8.5V14.3125C8.5 14.3622 8.48025 14.4099 8.44508 14.4451C8.40992 14.4802 8.36223 14.5 8.3125 14.5ZM12.3125 11.5H5.6875C5.63777 11.5 5.59008 11.4802 5.55492 11.4451C5.51975 11.4099 5.5 11.3622 5.5 11.3125V1.6875C5.5 1.63777 5.51975 1.59008 5.55492 1.55492C5.59008 1.51975 5.63777 1.5 5.6875 1.5H9V4.25C9 4.66422 9.33578 5 9.75 5H12.5V11.3125C12.5 11.3622 12.4802 11.4099 12.4451 11.4451C12.4099 11.4802 12.3622 11.5 12.3125 11.5ZM12.5 3.5H10.5V1.5H10.801C10.8507 1.5 10.8984 1.51975 10.9336 1.55491L12.4451 3.06641C12.4625 3.08382 12.4763 3.10449 12.4857 3.12724C12.4952 3.14999 12.5 3.17438 12.5 3.199V3.5Z"
            fill="currentcolor"
          />
        </svg>

        Duplicate
      </button>
      <button
        mat-menu-item
        [matMenuTriggerFor]="deleteRowConfirmation"
        *ngIf="params.showDelete && noOkay"
      >
        <mat-icon>delete</mat-icon> Delete
      </button>
    </ng-template>
  </mat-menu>
</ng-container>

<mat-menu #deleteRowConfirmation>
  <ng-template matMenuContent let-id="id">
    <button mat-menu-item class="delete" (click)="deleteRow(rowNode)">
      <mat-icon>delete</mat-icon>
      Confirm Delete
    </button>
  </ng-template>
</mat-menu>
